module.exports = "export default __webpack_public_path__ + &quot;2bbf1c60c1961461cfce18ff943d23a6.svg&quot;;"